import ChatConversationIcon from 'modules/common/components/Icons/ChatConversationIcon';
import ChipButton from 'modules/common/components/Layout/Header/ChipButton';
import { useIMCContext } from 'modules/IMC/common/context';
import { DrawerTypes } from 'modules/IMC/common/context/IMCContext.interface';

export default function Inbox() {
    // ---- Hooks ----
    const { currOpenDrawer, openDrawer } = useIMCContext();

    // ---- Handlers ----
    const handleClick = () => {
        openDrawer(currOpenDrawer === DrawerTypes.INBOX ? null : DrawerTypes.INBOX);
    };

    // ---- Render ----
    return (
        <ChipButton
            onClick={handleClick}
            icon={<ChatConversationIcon sx={{ fontSize: '1em' }} />}
            variant="outlined"
            label="Inbox"
        />
    );
}
